// IMPORTANT: Make sure this is in sync with functions/src/index.ts -> prepareDailyDigest
export enum TRAFFIC_SOURCE {
    direct = 'direct',
    referralOther = 'referral-other',
    xTwitter = 'x-twitter',
    twitch = 'twitch',
    tiktok = 'tiktok',
    youtube = 'youtube',
    linkedin = 'linkedin',
    facebook = 'facebook',
    instagram = 'instagram',
    substack = 'substack',
    email = 'email',
    chapterEmail = 'chapter-email',
    reddit = 'reddit',
    discord = 'discord',
    threads = 'threads',
    bluesky = 'bluesky',
    github = 'github',
    chatgpt = 'chatgpt',
    perplexity = 'perplexity',
    claude = 'claude',
    google = 'google',
    bing = 'bing',
    duckduckgo = 'duckduckgo',
    yahoo = 'yahoo',
    whatsapp = 'whatsapp',
    telegram = 'telegram',
    signal = 'signal',
    unknown = 'unknown',
}
